import { useLayoutEffect } from 'react';

interface IProps {
  setComplete: (status: boolean) => void;
}

export const AlreadyInUk = ({ setComplete }: IProps) => {
  useLayoutEffect(() => {
    setComplete(true);
  });

  return <></>;
};
